import React from "react";

import classnames from "classnames";
import { withStyleProps } from "Utils/styleProps";

import makeBem from "Utils/makeBem";

const bem = makeBem("HarmonyIcon");

type Props = {
  icon: string;
  size: "normal" | "large" | "2x";
  spacing: "none" | "left" | "right" | "both";
  className?: string;
};

class HarmonyIcon extends React.Component<Props> {
  static defaultProps = {
    spacing: "none",
    size: "normal",
  };

  render() {
    let { icon, size, spacing, className, ...other } = this.props;
    className = classnames(bem(), "hi", className, `hi-${icon}`, {
      [bem(null, `spacing-${spacing}`)]: spacing !== "none",
      [bem(null, size)]: size !== "normal",
    });

    return <i className={className} {...other} />;
  }
}

export default withStyleProps(HarmonyIcon);
